import React from 'react'

export default function FaceFeature({ scaleX, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} style={{ opacity: 0.2 }}>
      <path
        d="M0.209961 2.16003C2.76996 1.61003 5.37993 1.29004 7.98993 1.04004C10.5999 0.780039 13.2199 0.690044 15.8499 0.670044C18.4699 0.680044 21.0999 0.78002 23.7099 1.02002C26.3199 1.27002 28.9199 1.59003 31.4899 2.16003C30.1799 2.09003 28.88 1.99996 27.57 1.95996C26.27 1.88996 24.97 1.83005 23.66 1.80005C21.06 1.73005 18.4499 1.66005 15.8499 1.68005C13.2499 1.67005 10.65 1.73995 8.03998 1.81995C6.73998 1.84995 5.42994 1.90998 4.12994 1.97998C2.81994 1.99998 1.51996 2.09003 0.209961 2.16003Z"
        fill={outline}
      />
    </g>
  )
}
